import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=71d6efef&scoped=true&lang=pug&"
import script from "./CreateModal.vue?vue&type=script&lang=ts&"
export * from "./CreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=71d6efef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d6efef",
  null
  
)

export default component.exports